export default __webpack_public_path__ + "static/media/medal-6.eecc4e6f.svg";